// @flow

import React from 'react';
import type { Node } from 'react';
import { Row, Col } from '@riseart/antd-provider';

import { similarLinksCls } from 'shared_components/common/filters/links/Links.less';

type Props = {
  items: Object[],
  maxColumns?: number,
};

/**
 * FilterLinks
 *
 * @param {Props} props
 * @returns {Node}
 */
export function FilterLinks({ items, maxColumns = 4 }: Props): Node {
  if (!items || !items.length) {
    return null;
  }

  const total = items && items.length;
  const itemsPerColumn = Math.ceil(total / maxColumns);
  const totalColumns = Math.ceil(total / itemsPerColumn);
  const flexBoxGridCount = 24 / totalColumns;
  const columns = items.reduce(
    (accumulator, item, index) => {
      const columnIndex = Math.floor(index / itemsPerColumn);
      accumulator[columnIndex] = [...(accumulator[columnIndex] || []), item];
      return accumulator;
    },
    [...Array(totalColumns)],
  );

  return (
    <Row type="flex" justify="space-between" gutter={18} className={similarLinksCls}>
      {columns.map((columnItems, idx) => {
        return (
          <Col key={idx} xs={24} md={flexBoxGridCount}>
            <ul>
              {columnItems.map((item, itemIdx) => {
                return <li key={itemIdx}>{item}</li>;
              })}
            </ul>
          </Col>
        );
      })}
    </Row>
  );
}
